<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="container-fluid">
      <div class="card bg-light mb-3">
        <center><h2 class="card-header">Registry Requests</h2></center>
        <div class="card-body">
          <div class="card-text">
            <table class="table table-sm table-hover">
              <thead class="thead-dark">
                <tr>
                  <th scope="col">Registry Owner</th>
                  <th scope="col">Registry Name</th>
                  <th scope="col">Country</th>
                  <th scope="col">Request Date</th>
                  <th scope="col">Status</th>
                  <th scope="col">&nbsp;</th> <!-- Column for buttons to show IRR request -->
                  <th scope="col">&nbsp;</th> <!-- Column for button to navigate to IRR -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="irrRequest in irrRequests">
                  <th>{{irrRequest.irr_owner_name}}</th>
                  <th>{{irrRequest.proposed_irr_name}}</th>
                  <th>{{irrRequest.country}}</th>
                  <th>{{formatDate(irrRequest.created_at)}}</th>
                  <th v-html="status(irrRequest)"></th>
                  <th><a :href="'/irr-request/' + irrRequest.id + '/'" class="btn btn-info" role="button">View Registry Request</a></th>
                  <th><a v-if="irrRequest.irr_id && !irrRequest.irr_deleted" :href="'/irr/' + irrRequest.irr_id + '/'" class="btn btn-success" role="button">View Registry</a></th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        permissions: Object,
        irrRequests: [Object, Array],
      },
      methods: {
        status: function(irrRequest) {
          if(irrRequest.pending) {
            return '<i class="fa fa-question-circle text-info mr-2"></i><span class="text-info">Pending</span>';
          } else if(irrRequest.approved && irrRequest.irr_deleted) {
            // the registry created from this request has since been deleted (only system admins see this list entry's registry at all)
            var deletedOn = irrRequest.irr_deleted_at ? ' on ' + irrRequest.irr_deleted_at : '';
            return '<i class="fa fa-trash text-danger mr-2"></i><span class="text-danger">Approved - Registry Deleted' + deletedOn + '</span>';
          } else if(irrRequest.approved && irrRequest.irr_deactivated) {
            return '<i class="fa fa-pause-circle text-success mr-2"></i><span class="text-success">Approved - Registry Deactivated</span>';
          } else if(irrRequest.approved) {
            return '<i class="fa fa-check-circle text-success mr-2"></i><span class="text-success">Approved</span>';
          } else {
            return '<i class="fa fa-times-circle text-danger mr-2"></i><span class="text-danger">Declined</span>';
          }
        },
        formatDate: function(ts) {
          var date = new Date(ts);
          var day = date.getDate();
          var month = date.getMonth() + 1;
          var year = date.getFullYear();

          day = '0' + day;
          month = '0' + month;
          day = (day.length == 2) ? day : day.slice(1);
          month = (month.length == 2) ? month : month.slice(1);

          return year + '-' + month + '-' + day;
        },
      },
      mounted() {
        //
      }
    }
</script>
